import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import { AccordionItem, PageHeader } from "components";
import { useParams } from "duck";
import { useGetAnestheticProtocolQuery } from "requests";
import { Medications, RegionalBlocks } from "./components";

const AnestheticProtocol: React.FC = () => {
  const { id: anestheticProtocolId } = useParams();
  const { data: protocol } = useGetAnestheticProtocolQuery({
    variables: { _id: +anestheticProtocolId }
  });

  if (!protocol?.anestheticProtocol) {
    return null;
  }

  return (
    <>
      <PageHeader title="Anesthetic Protocols" backURL={-1} />
      <Box py={8}>
        <AccordionItem title={protocol.anestheticProtocol.name}>
          <Flex direction="column" rowGap={12}>
            <Medications />
            <RegionalBlocks />
          </Flex>
        </AccordionItem>
      </Box>
    </>
  );
};

export default AnestheticProtocol;
